import { create } from '@bufbuild/protobuf';

import { wsAppRequestManager } from '../WsAppApi';
import {
  GenerateUploadUrlRequest,
  GenerateUploadUrlRequestSchema,
} from '../types/upload/upload_requests_pb';
import { GenerateUploadUrlResponse } from '../types/upload/upload_responses_pb';
import { WsRequest } from './request.types';

export function getUploadUrlRequest(
  data: WsRequest<GenerateUploadUrlRequest>
): Promise<GenerateUploadUrlResponse> {
  return wsAppRequestManager.request<GenerateUploadUrlResponse>({
    case: 'generateUploadUrl',
    value: create(GenerateUploadUrlRequestSchema, data),
  });
}
